// extracted by mini-css-extract-plugin
export default {"container":"In-z","bubbleNav":"Jn-z","graphic":"Kn-z","contact":"Ln-z"};